var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.showDownloadSection)?_c('one-base-home-page',{staticClass:"one-product-files-section"},[_c('one-product-data-container',{attrs:{"title":_vm.$t('product_page.download')}},[_c('one-product-download',{attrs:{"product-id":_vm.$product.id}})],1)],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }